import { gql } from "graphql-request";

export const GET_PREF_ORIGIN_OPPORTUNITIES = gql`
  query PrefOriginOpportunities($input: PrefOriginInput!) {
    prefOriginOpportunities(input: $input) {
      data {
        htsNumberFull
        htsDescription
        countryOfOriginCode
        countryName
        program
        status
        totalEntries
        totalLines
        claimedEntries
        unclaimedEntries
        goodsValue
        totalDutyValue
        potentialSavings
        manufacturers
      }
      meta {
        countDocs
        pageNo
        pageSize
      }
      kpis {
        totalPotentialSavings
        opportunityCount
        fullyClaimedCount
        programCount
      }
      manufacturers {
        manufacturerID
        manufacturerName
        entryCount
      }
    }
  }
`;
